module.exports = __webpack_public_path__ + "static/ewm60.5bc55248.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ewm60.png
// module id = +m8W
// module chunks = 0